// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xSc1","signatureBlock":"Footer_signatureBlock__1K4o-","signature":"Footer_signature__1usWa"};